import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { UtilityService } from '../../services/utility/utility.service';

@Component({
  selector: 'upsc-search',
  templateUrl: './search.component.html',
  styleUrls: ['./search.component.scss'],
})
export class SearchComponent implements OnInit {
  @Output() searchSubmitted: EventEmitter<string> = new EventEmitter<string>();

  public formGroup: UntypedFormGroup;
  public isShowSearchOverlay = false;
  public isSearching = false;

  constructor(private formBuilder: UntypedFormBuilder,
              private utilityService: UtilityService) {
  }

  public ngOnInit() {
    this.formGroup = this.formBuilder.group({
      keyword: [''],
    });
  }

  public onFormSubmitted(event, form) {
    event.preventDefault();

    if (!form.keyword) {
      return;
    }

    this.isSearching = true;

    // TODO: connect to API to do a real search or just emit the keyword to a parent component.
    this.searchSubmitted.emit(form.keyword);

    this.utilityService.delay(() => {
      this.isSearching = false;
    });
  }

  public overlayKeyDown(event) {
    if (event.keyCode !== 27) {
      return;
    }

    this.isShowSearchOverlay = false;
  }
}
